import React, { memo, useRef, useState, useCallback } from 'react';
import Button from 'jd-library/Button';
import Loader from 'jd-library/Loader';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import styles from './Styles/upload-prompt.scss';
import { isValidExcel } from './ExportHistorySlider.utils';
import { showToastMessage } from '../../../actions/toastmessage';

const UploadPrompt = (props) => {
  const [showLoader, setLoader] = useState(() => false);
  const inputref = useRef(null);
  const dispatch = useDispatch();


  let sourceFlag=""
  if(props.session.viaOmni){
      sourceFlag="&sourceFlag=1"
  } else{
      sourceFlag="&sourceFlag=2"
  }

  const handleClick = () => {
    inputref.current.value = null;
    inputref.current.click();
  }

  const handleChange = (e) => {
    const { target: { files } } = e;
    const { error } = isValidExcel(files[0]);
    if (error) {
      dispatch(showToastMessage({
        showToastMessage: true,
        type: 'error',
        message: error,
        duration: 5000,
      }))
    } else {
      let params = {
        action: 'updateHeaderMapping',
        srcType: 'updateProductListImport',
        sourceFlag: props.session.viaOmni ? '1' : '2'
      }
      let formData = new FormData();
      formData.append('file', files[0]);
      setLoader(() => true);
      setTimeout(() => {
        axios.post('/marketplace/static/php/web/b2bWebsite.php', formData, { params })
          .then(({ data }) => {
            setLoader(() => false);
            if (data.isSuccess) {
              props.setCurrentStep();
            }else if(!data.isSuccess){
              dispatch(showToastMessage({
                showToastMessage: true,
                type: 'error',
                message: data?.msg,
                duration: 5000,
              }))
            }
          })
      }, 1200);
    }
  }

  const handleDownloadLink = useCallback(() => {
    let params = {
      action: 'updateHeaderMapping',
      srcType: 'updateProductList',
      sourceFlag: props.session.viaOmni ? '1' : '2'
    }
    axios.get('/marketplace/static/php/web/b2bWebsite.php', { params })
      .then(({ data }) => {
        if (data.isSuccess) {
          props.setCurrentStep();
        }
      })
      .catch((err) => {
        console.log(err);
      })
  }, [])

  return (
    <>
      <div className={styles['upload-prompt']}>
        <div style={{ textAlign: 'center' }}>
          <img src='https://image1.jdomni.in/jdomni_email/undraw_upload_87y9_2004281701.png' />
          <div className={styles['prompt-heading']}>Select File to Bulk Update Products</div>
          <div className={styles['formats']}>You can <span style={{ color: '#0076D7', cursor: 'pointer' }} onClick={handleDownloadLink}>
            download </span> your current catalogue file(.xlsx) to update existing product information.
          </div>
          <Button
            size='md'
            className={styles['upload-btn'] + (showLoader ? styles['with-loader'] : '')}
            clickHandler={handleClick}
            disabled={showLoader}
          >
            {showLoader ?
              (
                <div style={{ margin: 0 }}>
                  <Loader className={styles['upload-btn-loader']} /> Uploading
                </div>
              ) :
              'Choose File'
            }
          </Button>
          <input
            ref={inputref}
            type="file"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            style={{ display: 'none' }}
            onChange={handleChange}
          />
          <div className={styles['supported-files']}>
            Supported Formats Allowed .XLS and .XLSX
          </div>
        </div>
      </div>
    </>
  )
}

export default memo(UploadPrompt);